<template>
  <v-card width="1200" height="350" flat>
    <v-carousel
      :continuous="false"
      :show-arrows="false"
      :style="[isRouteCo() ? { height: '730px' } : { height: '450px' }]"
      delimiter-icon="mdi-circle"
      hide-delimiter-background
      height="auto"
      class="d-flex justify-center secundary5 mt-n9"
    >
      <v-carousel-item v-for="(items, index) in modelForm" :key="index">
        <v-sheet class="d-flex secundary5 justify-center">
          <v-form
            class="d-flex flex-nowrap secundary5 justify-center contentCentral mx-3"
            @input="handleEvents"
          >
            <v-form-base
              v-if="isRouteCo_0mt"
              class="d-flex justify-center"
              :schema="items.schemaForm"
              :model="items.modelForm"
              @input="handleEvents"
            />
            <v-form-base
              v-if="isRouteCo_7mt"
              class="d-flex justify-center mt-7"
              :schema="items.schemaForm"
              :model="items.modelForm"
              @input="handleEvents"
            />
          </v-form>
        </v-sheet>
      </v-carousel-item>
    </v-carousel>

    <v-card-actions class="mt-n8" v-for="(btn, index) in coBtnIcons" :key="index">
      <v-row class="d-flex justify-start mx-1" v-if="observerHCP === false">
        <v-col xs="3" class="d-flex flex-xs-wrap pa-0">
          <v-btn small color="secundary3" class="d-flex mx-sm-2 mx-md-6" style="z-index: 1" @click="insertRoute(btn.backRouteApli)" v-if="coBtnIcons[0].btnResults == true">
            <v-icon>mdi-arrow-left</v-icon>
          </v-btn>
          <v-btn small color="secundary3" class="d-flex mx-sm-2 mx-md-6" style="z-index: 1" @click="insertRoute(btn.backRouteList)" v-if="coBtnIcons[0].btnResults == false">
            <v-icon>mdi-arrow-left</v-icon>
          </v-btn>
          
          <v-btn small color="secundary3" class="d-flex mx-sm-2 mx-md-6" @click="cleanItems()" style="z-index: 1">
            <span class="text-body-2 text-capitalize">{{ btn.clean }}</span>
          </v-btn>
        </v-col>
        
        <v-col xs="6"> </v-col>
        
        <v-col xs="3" class="d-flex flex-xs-wrap justify-end pa-0">
          <v-btn small color="primary" class="d-flex mx-sm-2 mx-md-6" style="z-index: 1" @click="insertRoute(btn.resultRoute), btnResult()" v-if="coBtnIcons[0].btnResults === true">
            <span class="text-body-2 text-capitalize">{{ btn.results }}</span>
          </v-btn>
          <v-btn small color="primary" class="d-flex mx-sm-2 mx-md-6" style="z-index: 1" @click="ageVerifAndSave()" v-if="btn.calification">
            <span class="text-body-2 text-capitalize">{{ btn.calification }}</span>
          </v-btn>
          <v-btn small color="primary" class="d-flex mx-sm-2 mx-md-6" style="z-index: 1" @click="ageVerifAndSave()" v-if="btn.update">
            <span class="text-body-2 text-capitalize">{{ btn.update }}</span>
          </v-btn>
        </v-col>
      </v-row>
    </v-card-actions>
  </v-card>
</template>

<script>
import VFormBase from 'vuetify-form-base';

export default {
  name: 'VSlidesCo',
  components: { VFormBase },
  props: ['coBtnAdd', 'coBtnIcons', 'modelForm', 'handleEvents', 'ageVerifAndSave', 'btnResult', 'observerHCP'],
  
  data() {
    return {
      length: 2,
      onboarding: 2,
      localModelForm: this.modelForm ? JSON.parse(JSON.stringify(this.modelForm)) : []
    };
  },

  watch: {
    // 3. Si el padre cambia el modelForm (por ejemplo al cargar otro test), actualizamos la copia
    modelForm: {
      handler(newVal) {
        this.localModelForm = JSON.parse(JSON.stringify(newVal));
      },
      deep: true
    }
  },

  computed: {
    // 4. Actualizamos computadas para usar la versión local
    isRouteCo_0mt() {
      if (!this.localModelForm || !this.localModelForm[0]) return false;
      let NumItemsGroup1 = Object.keys(this.localModelForm[0].schemaForm.group1.schema).length;
      return NumItemsGroup1 > 16;
    },
    isRouteCo_7mt() {
      if (!this.localModelForm || !this.localModelForm[0]) return false;
      let NumItemsGroup1 = Object.keys(this.localModelForm[0].schemaForm.group1.schema).length;
      return NumItemsGroup1 <= 16;
    },
  },

  methods: {
    insertRoute(ruta) {
      this.$router.push(ruta);
    },
    isRouteCo() {
      const routes = ['co-04', 'co-05', 'co-39', 'co-41', 'co-45'];
      return routes.includes(this.$route.name);
    },
    
    // 5. El método Limpiar ahora modifica su propia copia y avisa al padre
    cleanItems() {
      this.localModelForm.forEach((item) => {
        const nuevoModelo = {};
        Object.keys(item.modelForm).forEach((groupKey) => {
          nuevoModelo[groupKey] = {};
        });
        // Al asignar un objeto nuevo completo, Vue 2 sí detecta el cambio sin $set
        item.modelForm = nuevoModelo; 
      });
      
      this.$emit('update:modelForm', this.localModelForm);
    },
  },
};
</script>

<style>
.contentCentral { width: 96%; min-height: 340px; }
.label-left .v-label { left: 0 !important; transform-origin: top left !important; }
.my-text-field .v-input__prepend-outer { min-width: 140px; }
</style>